import { Box, Grid, Typography } from '@mui/material'
import { FunctionComponent } from 'react'

export const Message:FunctionComponent<{status: string, message: string}> = ({status, message}) => {
return (
  <Box sx={{ height: '180px' }}>
    <Grid container spacing={2}>
      <Grid item xs={12} md={12} lg={12}>
        <Typography variant="h5" sx={{ mb: 3 }}>
          {status}
        </Typography>
      </Grid>
      <Box
        sx={{
          width: '100%',
          ml: 2,
        }}
      >
        <Typography variant="body1">
          {message}
        </Typography>
      </Box>
    </Grid>
  </Box>
)
}